import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SubtleBadge from '@/components/common/SubtleBadge';
import ChildrensTooltip from '@/components/common/ChildrensTooltip';
import type { AiContentHistoryRow } from '@/app/ContentTools/types/aiContentAnalysisApiTypes';

type AiContentHistoryStatusRendererProps = {
  errorCode?: AiContentHistoryRow['error_code'] | null;
  errorMessage?: AiContentHistoryRow['error_message'] | null;
  errorDetails?: AiContentHistoryRow['error_details'] | null;
  errorNet?: AiContentHistoryRow['error_net'] | null;
};

const AiContentHistoryStatusRenderer = ({
  errorCode,
  errorMessage,
  errorDetails,
  errorNet
}: AiContentHistoryStatusRendererProps) => {
  if (errorCode == null) {
    return (
      <div className="w-100 d-flex h-100 align-items-center justify-content-center">
        <SubtleBadge pill bg="success" className="d-block fs--2 text-nowrap">
          <FontAwesomeIcon icon="check" transform="shrink-2" className="mx-1" />
          پایان موفق
        </SubtleBadge>
      </div>
    );
  }

  const tooltipMessage =
    errorMessage || errorDetails || errorNet || 'پیام خطا در دسترس نیست';

  return (
    <div className="w-100 d-flex h-100 align-items-center justify-content-center">
      <SubtleBadge pill bg="danger" className="d-block fs--2 text-nowrap">

        <ChildrensTooltip className="" html={<>{tooltipMessage}</>} placement="top">
          <FontAwesomeIcon className="me-1" icon="ban" transform="shrink-2" />
          {`کد خطا ${errorCode}`}
          <FontAwesomeIcon className="mx-1" icon="exclamation-circle" />
        </ChildrensTooltip>
      </SubtleBadge>
    </div>
  );
};

export default AiContentHistoryStatusRenderer;
